import { constants } from "@newsela/angelou";

const {
  colors: { ui },
} = constants;

// TO DO: SWAP WITH ANGELOU COLORS
export const TEACHER_USAGE_DATA_CARD_COLOR = "#DAF4F8";
export const STUDENT_USAGE_DATA_CARD_COLOR = ui.beige[50];
